import { DomainGroup, domainGroupEnum } from "@shared/utils/domain-group";
import { useDomainGroup } from "./useDomainGroup";

type AppDescriptionVariant = "short" | "long";

const APP_DESCRIPTION: Record<
  AppDescriptionVariant,
  Record<DomainGroup, string>
> = {
  short: {
    [domainGroupEnum.SIDEKICK]: "Sidekick - Real Estate Assistant",
    [domainGroupEnum.RADAR]: "Radar by Sidekick - Real Estate Assistant",
  },
  long: {
    [domainGroupEnum.SIDEKICK]:
      "Sidekick is the leading AI assistant purpose-built to help agents and brokerages save time and grow.",
    [domainGroupEnum.RADAR]:
      "Radar by Sidekick turns signals from your inbox and your contacts' social activity into a clear list of who needs your attention next.",
  },
};

export const useAppDescription = (
  variant: AppDescriptionVariant = "short",
): string => APP_DESCRIPTION[variant][useDomainGroup()];
